
import React, { useEffect, useState, useRef } from 'react'

import ld from 'lodash'
const __ = ld.noConflict()

import classNames from 'classnames'

import styles from './accordion.module.sass'

import BlockWrapper from './layout/block_wrapper'
import ScrollAnimation from './layout/scroll_animation'

import library from './library'

function Accordion(props) {
	const accordionRef = useRef(null)
	const fields = props.fields
	const accordionItems = fields.items && fields.items.map(item => { return {...item} })
	const [state, setState] = useState({items: accordionItems})
	const [loaded, setLoaded] = useState(false)

	useEffect(() => {
		const onPageLoad = () => {
			setLoaded(true)
		}

		if (document.readyState === 'complete') {
			onPageLoad()
		} else {
			window.addEventListener('load', onPageLoad, false)
			return () => window.removeEventListener('load', onPageLoad)
		}
	}, [])

	//when loaded changed, if true add data-height attribute to accordion items
	useEffect(() => {
		if (loaded) {
			const accordionItems = accordionRef.current.querySelectorAll(`.${styles.item}`)
			__.each(accordionItems, (item, i) => {
				const body = item.querySelector(`.${styles.body}`)
				const content = body.querySelector(`.${styles.content}`)
				const contentHeight = content.scrollHeight

				//add data attribute to body
				body.setAttribute('data-height', contentHeight)
			})
		}
	}, [loaded])

	const handleItemClick = (el, index) => {
		el.preventDefault()

		const accordionItems = state.items
		const accordionContent = el.currentTarget.parentNode.querySelector(`.${styles.body}`)

		if (accordionItems[index].active){
			accordionItems[index].active = false
			accordionContent.style.height = '0px'
			accordionContent.style.overflow = 'hidden'
		} else {
			accordionItems[index].active = true
			//get value of data-height attribute
			const contentHeight = accordionContent.getAttribute('data-height')
			accordionContent.style.height = contentHeight + 'px'
		}

		setState({items: accordionItems})
	}
	
	return <div ref={accordionRef} className={classNames(styles.accordion, props.toggle && styles[props.toggle], props.theme && styles[props.theme])}>
			<ScrollAnimation styles={styles}>
				<BlockWrapper className={classNames(styles.accordion_wrapper)}>
				{state.items && state.items.map((item, i) => {

					const renderedComponents = []

					if(item.raw_content){
						item.content = item.raw_content

						renderedComponents.push(<div className={classNames(styles.content)} dangerouslySetInnerHTML={{__html: item.content}}></div>)
					} else {
						__.each(item.content, (component, i) => {
							const type = component.acf_fc_layout

							const Component = library[type];
							const renderedComponent = <Component key={`component_${type}_${i}`} fields={component} accordionContent={true} />

							renderedComponents.push(renderedComponent)
						})
					}

					return <div className={classNames(styles.item, item.active == true ? styles.active : '')} key={i} data-accordion-item>
						<div className={classNames(styles.title)} onClick={(e) => handleItemClick(e, i)}>
							<h2 className='h3'>{item.title}</h2>
							<button className={styles.arrow} aria-label='accordion expand'></button>
						</div>
						<div className={classNames(styles.body)}>
							<div className={classNames(styles.content)}>
								{renderedComponents}
							</div>
						</div>
					</div>
				})}
				</BlockWrapper>
			</ScrollAnimation>
	</div>
}

export default Accordion